
export class ChangePhoneModel {
    public customerId: number;
    public phone: number;
    public code: string;
}

